export type TbTestGuidedUploadStep =
  | "test-type-selection"
  | "instructions"
  | "upload"
  | "file-preview"
  | "date-validation"
  | "invalid-test-error"
  | "success";

export const TB_TEST_TYPE = {
  TUBERCULIN_SKIN_TEST: "TUBERCULIN_SKIN_TEST",
  TB_BLOOD_TEST: "TB_BLOOD_TEST",
  CHEST_X_RAY: "CHEST_X_RAY",
} as const;

export type TbTestType = (typeof TB_TEST_TYPE)[keyof typeof TB_TEST_TYPE];
